/* ============================================================
   NKY Cart Drawer — nky-cart-drawer.js
   Place in: assets/
   ============================================================ */

(function () {
  'use strict';

  var NKYCart = {

    FREE_SHIPPING_THRESHOLD: 2990,
    GALLERY_CODE: 'GALLERY15',
    REGULAR_CODE: 'NOOK10',

    // ── Init ──────────────────────────────────────────────────
    init: function () {
      this.drawer   = document.getElementById('nky-cart-drawer');
      this.overlay  = document.getElementById('nky-cart-overlay');
      this.closeBtn = document.getElementById('nky-cart-close');

      if (!this.drawer) return;

      this.bindClose();
      this.bindCouponModal();
      this.bindSaveCart();
      this.bindCheckoutBtn();
      this.bindLightbox();
      this.bindScrollLock();
      this.interceptCartOpeners();
      this.interceptATC();
      this.fetchAndRender();
    },

    // ── Open / Close ──────────────────────────────────────────
    open: function () {
      this.fetchAndRender();
      this.drawer.classList.add('nky-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.overlay.classList.add('nky-visible');
      document.body.classList.add('nky-cart-open');
      this.bindQAStrip();
    },

    close: function () {
      this.drawer.classList.remove('nky-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.overlay.classList.remove('nky-visible');
      document.body.classList.remove('nky-cart-open');
    },

    bindClose: function () {
      var self = this;
      this.closeBtn.addEventListener('click', function () { self.close(); });
      this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          self.closeCouponModal();
          self.close();
        }
      });
    },

    // ── Coupon Modal ──────────────────────────────────────────
    bindCouponModal: function () {
      var self      = this;
      var modal     = document.getElementById('nky-coupon-modal');
      var openBtn   = document.getElementById('nky-coupon-btn');
      var closeBtn  = document.getElementById('nky-coupon-modal-close');
      var copyBtns = document.querySelectorAll('.nky-copy-btn');

      if (!modal || !openBtn) return;

      openBtn.addEventListener('click', function () {
        modal.classList.add('nky-modal-open');
        modal.setAttribute('aria-hidden', 'false');
      });

      closeBtn.addEventListener('click', function () { self.closeCouponModal(); });

      modal.addEventListener('click', function (e) {
        if (e.target === modal) self.closeCouponModal();
      });

      copyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var code = btn.getAttribute('data-code');
          try {
            navigator.clipboard.writeText(code);
          } catch(e) {
            var el = document.createElement('textarea');
            el.value = code;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
          }
          btn.textContent = 'Copied!';
          btn.classList.add('nky-copied');
          setTimeout(function () {
            btn.textContent = 'Copy';
            btn.classList.remove('nky-copied');
          }, 2000);
        });
      });
    },

    closeCouponModal: function () {
      var modal = document.getElementById('nky-coupon-modal');
      if (modal) {
        modal.classList.remove('nky-modal-open');
        modal.setAttribute('aria-hidden', 'true');
      }
    },

    // ── Save cart summary ─────────────────────────────────────
    bindSaveCart: function () {
      var self = this;
      var btn  = document.getElementById('nky-save-cart-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var date = new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
            var rows = '';
            cart.items.forEach(function (item) {
              var variants = [];
              if (item.variant_title && item.variant_title !== 'Default Title') {
                item.variant_title.split(' / ').forEach(function (v) { variants.push(v.trim()); });
              }
              var imgSrc = '';
              if (item.featured_image && item.featured_image.url) {
                imgSrc = item.featured_image.url.replace(/(\.\w+)(\?.*)?$/, '_160x160_crop_center$1');
              }
              rows += '<tr style="border-bottom:1px solid #f0ece6;">';
              rows += '<td style="padding:12px 8px;width:70px;"><a href="https://www.nookatyou.com' + item.url + '" target="_blank"><img src="' + imgSrc + '" style="width:60px;height:60px;object-fit:cover;border-radius:2px;" /></a></td>';
              rows += '<td style="padding:12px 8px;">';
              rows += '<div style="margin-bottom:3px;"><a href="https://www.nookatyou.com' + item.url + '" target="_blank" style="font-family:Georgia,serif;font-size:13px;font-weight:500;color:#0F1113;text-decoration:none;border-bottom:1px solid #e0d9d0;">' + self.escHtml(item.product_title) + '</a></div>';
              if (variants.length) {
                rows += '<div style="font-family:Arial,sans-serif;font-size:11px;color:#888;">' + variants.map(self.escHtml).join(' &middot; ') + '</div>';
              }
              rows += '</td>';
              rows += '<td style="padding:12px 8px;font-family:Arial,sans-serif;font-size:12px;color:#555;text-align:center;">' + item.quantity + '</td>';
              rows += '<td style="padding:12px 8px;font-family:Arial,sans-serif;font-size:13px;font-weight:500;color:#0F1113;text-align:right;">' + self.formatMoney(item.final_price * item.quantity) + '</td>';
              rows += '</tr>';
            });

            var html = '<div style="max-width:600px;margin:0 auto;font-family:Arial,sans-serif;">';
            html += '<div style="border-bottom:3px solid #D4AF37;padding-bottom:16px;margin-bottom:24px;display:flex;justify-content:space-between;align-items:center;">';
            html += '<a href="https://www.nookatyou.com" target="_blank" style="display:block;"><img src="https://cdn.shopify.com/s/files/1/0321/0910/1188/files/Final-logo2.1_1.png?v=1777284613" alt="Nook At You" style="height:48px;width:auto;display:block;" /></a>';
            html += '<div style="font-family:Arial,sans-serif;font-size:11px;color:#aaa;text-align:right;">Cart Summary<br>' + date + '</div>';
            html += '</div>';
            html += '<table style="width:100%;border-collapse:collapse;">';
            html += '<thead><tr style="border-bottom:2px solid #0F1113;">';
            html += '<th style="padding:8px;font-family:Arial,sans-serif;font-size:11px;color:#aaa;font-weight:400;text-align:left;letter-spacing:0.08em;text-transform:uppercase;"></th>';
            html += '<th style="padding:8px;font-family:Arial,sans-serif;font-size:11px;color:#aaa;font-weight:400;text-align:left;letter-spacing:0.08em;text-transform:uppercase;">Artwork</th>';
            html += '<th style="padding:8px;font-family:Arial,sans-serif;font-size:11px;color:#aaa;font-weight:400;text-align:center;letter-spacing:0.08em;text-transform:uppercase;">Qty</th>';
            html += '<th style="padding:8px;font-family:Arial,sans-serif;font-size:11px;color:#aaa;font-weight:400;text-align:right;letter-spacing:0.08em;text-transform:uppercase;">Price</th>';
            html += '</thead><tbody>' + rows + '</tbody>';
            html += '<tfoot><tr>';
            html += '<td colspan="3" style="padding:14px 8px;font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#0F1113;text-align:right;">Subtotal</td>';
            html += '<td style="padding:14px 8px;font-family:Arial,sans-serif;font-size:15px;font-weight:700;color:#0F1113;text-align:right;">' + self.formatMoney(cart.total_price) + '</td>';
            html += '</tr></tfoot></table>';
            html += '<div style="margin-top:24px;padding:16px;background:#fdfaf6;border:1px solid #e8e2d9;border-radius:4px;font-family:Arial,sans-serif;font-size:12px;color:#555;text-align:center;line-height:1.7;">';
            html += '<strong style="color:#0F1113;display:block;margin-bottom:4px;">This is for your personal reference only.</strong>';
            html += 'If you need to share your cart with us, please screenshot this page and send it to us on WhatsApp. We are unable to open PDF files — a screenshot works best.';
            html += '<br><br><a href="https://wa.me/917358792364" style="display:inline-flex;align-items:center;gap:8px;background:#25D366;color:#fff;font-family:Arial,sans-serif;font-size:12px;font-weight:600;padding:9px 20px;border-radius:4px;text-decoration:none;">&#x1F4AC; +91-7358792364</a>';
            html += '</div>';
            html += '</div>';

            var fullHtml = '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Nook At You — Cart Summary</title>';
            fullHtml += '<style>body{margin:0;padding:40px 20px;font-family:Arial,sans-serif;background:#fff;max-width:700px;margin:0 auto;}</style>';
            fullHtml += '</head><body>' + html + '</body></html>';

            var encoded = 'data:text/html;charset=utf-8,' + encodeURIComponent(fullHtml);
            var a        = document.createElement('a');
            a.href       = encoded;
            a.download   = 'nookatyou-cart-summary.html';
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            setTimeout(function () { document.body.removeChild(a); }, 1000);
          })
          .catch(function (err) {
            console.warn('NKY Save Cart error', err);
          });
      });
    },

    // ── Checkout button ───────────────────────────────────────
    bindCheckoutBtn: function () {
      var btn = document.getElementById('nky-checkout-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var text    = document.getElementById('nky-checkout-text');
        var spinner = document.getElementById('nky-checkout-spinner');
        if (text)    text.style.display    = 'none';
        if (spinner) spinner.style.display = 'inline-flex';
        btn.classList.add('nky-loading');
      });

      window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
          var text    = document.getElementById('nky-checkout-text');
          var spinner = document.getElementById('nky-checkout-spinner');
          if (text)    text.style.display    = 'inline';
          if (spinner) spinner.style.display = 'none';
          btn.classList.remove('nky-loading');
        }
      });
    },

    // ── QA strip scroll progress + desktop drag + arrows ─────
    bindQAStrip: function () {
      var scroll   = document.getElementById('nky-qa-scroll');
      var bar      = document.getElementById('nky-qa-bar');
      var prevBtn  = document.getElementById('nky-qa-prev');
      var nextBtn  = document.getElementById('nky-qa-next');
      if (!scroll || scroll._nkyBound) return;
      scroll._nkyBound = true;

      // Load lazy images
      scroll.querySelectorAll('img[data-src]').forEach(function (img) {
        if (img.getAttribute('data-src')) {
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
        }
      });

      if (bar) {
        scroll.addEventListener('scroll', function () {
          var scrollable = scroll.scrollWidth - scroll.clientWidth;
          bar.style.width = scrollable > 0 ? (scroll.scrollLeft / scrollable) * 100 + '%' : '0%';
        }, { passive: true });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scroll.scrollBy({ left: -160, behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scroll.scrollBy({ left: 160, behavior: 'smooth' });
        });
      }

      var isDown = false, startX, savedLeft;
      scroll.addEventListener('mousedown', function (e) {
        isDown    = true;
        startX    = e.pageX;
        savedLeft = scroll.scrollLeft;
        scroll.style.cursor = 'grabbing';
      });
      document.addEventListener('mouseup', function () {
        if (isDown) { isDown = false; scroll.style.cursor = 'grab'; }
      });
      document.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        scroll.scrollLeft = savedLeft - (e.pageX - startX) * 1.5;
      });
    },

    // ── QA Lightbox ───────────────────────────────────────────
    bindLightbox: function () {
      var lightbox = document.getElementById('nky-qa-lightbox');
      var lbImg    = document.getElementById('nky-qa-lightbox-img');
      var lbClose  = document.getElementById('nky-qa-lightbox-close');
      var lbBack   = document.getElementById('nky-qa-lightbox-backdrop');
      if (!lightbox || lightbox._nkyLbBound) return;
      lightbox._nkyLbBound = true;

      document.getElementById('nky-qa-scroll') && document.getElementById('nky-qa-scroll').addEventListener('click', function (e) {
        var img = e.target.closest('.nky-qa-img');
        if (!img) return;
        var full = img.getAttribute('data-full') || img.src;
        lbImg.src = full;
        lightbox.classList.add('nky-lb-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('nky-cart-open');
      });

      function closeLightbox() {
        lightbox.classList.remove('nky-lb-open');
        lightbox.setAttribute('aria-hidden', 'true');
        lbImg.src = '';
      }

      lbClose.addEventListener('click', closeLightbox);
      lbBack.addEventListener('click', closeLightbox);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('nky-lb-open')) closeLightbox();
      });
    },

    // ── Prevent body scroll behind drawer on iOS ─────────────
    bindScrollLock: function () {
      var drawer = this.drawer;
      var body   = document.getElementById('nky-cart-body');
      if (!drawer) return;

      drawer.addEventListener('touchmove', function (e) {
        if (body && body.contains(e.target)) return;
        e.preventDefault();
      }, { passive: false });
    },

    // ── Exit intent ───────────────────────────────────────────
    bindExitIntent: function () {
      var self     = this;
      var modal    = document.getElementById('nky-exit-intent');
      var dismiss  = document.getElementById('nky-exit-dismiss');
      var exitBtn  = document.getElementById('nky-exit-checkout');
      if (!modal) return;

      this.closeBtn.addEventListener('click', function (e) {
        var count = parseInt(document.getElementById('nky-cart-count').textContent, 10);
        var shown = sessionStorage.getItem('nky_exit_shown');
        if (count > 0 && !shown) {
          e.stopImmediatePropagation();
          modal.classList.add('nky-exit-open');
          sessionStorage.setItem('nky_exit_shown', '1');
        }
      }, true);

      dismiss.addEventListener('click', function () {
        modal.classList.remove('nky-exit-open');
        self.close();
      });

      exitBtn.addEventListener('click', function () {
        modal.classList.remove('nky-exit-open');
      });

      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          modal.classList.remove('nky-exit-open');
          self.close();
        }
      });
    },

    // ── Intercept cart openers ────────────────────────────────
    interceptCartOpeners: function () {
      var self = this;
      document.querySelectorAll('a[href="/cart"], .js-drawer-open-cart, [data-cart-toggle], .site-header__cart').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });
      document.addEventListener('cart:open', function () { self.open(); });
      document.addEventListener('drawer:open', function (e) {
        if (e.detail && e.detail.id === 'CartDrawer') self.open();
      });
    },

    // ── Listen for Impulse's ATC events ──────────────────────
    interceptATC: function () {
      var self = this;
      document.addEventListener('ajaxProduct:added', function () { self.open(); });
      document.addEventListener('cart:item-added',   function () { self.open(); });
      document.addEventListener('product:added',     function () { self.open(); });
    },

    // ── Fetch & render ────────────────────────────────────────
    fetchAndRender: function () {
      var self = this;
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function (err) { console.warn('NKY Cart fetch error', err); });
    },

    render: function (cart) {
      this.renderCount(cart.item_count);
      this.renderShippingBar(cart.total_price);
      this.renderItems(cart);
      this.renderFooter(cart);
    },

    // ── Count ─────────────────────────────────────────────────
    renderCount: function (count) {
      var el = document.getElementById('nky-cart-count');
      if (el) el.textContent = count;
      document.querySelectorAll('.cart-count, .cart__count, [data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    },

    // ── Shipping bar ──────────────────────────────────────────
    renderShippingBar: function (totalPriceCents) {
      var total     = totalPriceCents / 100;
      var remaining = this.FREE_SHIPPING_THRESHOLD - total;
      var progress  = Math.min((total / this.FREE_SHIPPING_THRESHOLD) * 100, 100);
      var label     = document.getElementById('nky-shipping-label');
      var amount    = document.getElementById('nky-shipping-amount');
      var fill      = document.getElementById('nky-bar-fill');
      if (!label) return;

      if (progress >= 100) {
        label.innerHTML = 'You\'ve unlocked <strong>free shipping</strong>';
        amount.style.color = '#3B6D11';
        amount.textContent = 'Free';
      } else {
        label.innerHTML = 'Add <span style="color:#D4AF37;font-weight:500;">' + this.formatMoney(remaining * 100) + '</span> more for free shipping';
        amount.style.color = '#D4AF37';
        amount.textContent = this.formatMoney(total * 100) + ' / ' + this.formatMoney(this.FREE_SHIPPING_THRESHOLD * 100);
      }
      fill.style.width = progress + '%';
    },

    // ── Items ─────────────────────────────────────────────────
    renderItems: function (cart) {
      var self      = this;
      var container = document.getElementById('nky-cart-items');
      var empty     = document.getElementById('nky-empty-state');
      var recs      = document.getElementById('nky-recommendations');
      var footer    = document.getElementById('nky-cart-footer');
      if (!container) return;

      if (cart.item_count === 0) {
        container.innerHTML = '';
        empty.style.display = 'flex';
        if (recs) recs.style.display = 'none';
        footer.style.display = 'none';
        return;
      }

      empty.style.display = 'none';
      footer.style.display = 'block';

      var html = '';
      cart.items.forEach(function (item) {
        var variants     = [];
        var deliveryDate = '';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          item.variant_title.split(' / ').forEach(function (v) { variants.push(v.trim()); });
        }
        if (item.properties) {
          Object.keys(item.properties).forEach(function (key) {
            var val = item.properties[key];
            if (!val) return;
            if (key.charAt(0) === '_') return;
            if (key.toLowerCase().indexOf('terms') !== -1) return;
            if (val.toString().toLowerCase().indexOf('i understand') !== -1) return;
            if (key.toLowerCase().indexOf('estimated') !== -1 || key.toLowerCase().indexOf('delivery') !== -1) {
              deliveryDate = val; return;
            }
            variants.push(val);
          });
        }

        var imgSrc = '';
        if (item.featured_image && item.featured_image.url) {
          imgSrc = item.featured_image.url.replace(/(\.\w+)(\?.*)?$/, '_160x160_crop_center$1');
        } else if (item.image) {
          imgSrc = item.image.replace(/(\.\w+)(\?.*)?$/, '_160x160_crop_center$1');
        }

        var imgHtml = imgSrc
          ? '<a href="' + item.url + '"><img class="nky-item-img" src="' + imgSrc + '" alt="' + self.escHtml(item.product_title) + '" loading="lazy"/></a>'
          : '<div class="nky-item-img-placeholder"></div>';

        var lineOriginal = item.original_price * item.quantity;
        var lineFinal    = item.final_price * item.quantity;
        var priceHtml = item.original_price !== item.final_price
          ? '<span style="text-decoration:line-through;color:#bbb;font-size:11px;margin-right:4px;">' + self.formatMoney(lineOriginal) + '</span><span class="nky-item-price" style="color:#c0392b;">' + self.formatMoney(lineFinal) + '</span>'
          : '<span class="nky-item-price">' + self.formatMoney(lineFinal) + '</span>';

        html += '<div class="nky-item" data-key="' + item.key + '">';
        html += imgHtml;
        html += '<div class="nky-item-details">';
        html += '<a href="' + item.url + '" class="nky-item-title">' + self.escHtml(item.product_title) + '</a>';
        if (variants.length) {
          html += '<p class="nky-item-variants">' + variants.map(self.escHtml).join(' \u00b7 ') + '</p>';
        }
        if (deliveryDate) {
          html += '<p class="nky-item-delivery"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg> Est. ' + self.escHtml(deliveryDate) + '</p>';
        }
        html += '<div class="nky-item-bottom">';
        html += '<div class="nky-qty-wrapper">';
        html += '<button class="nky-qty-btn nky-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" type="button">\u2212</button>';
        html += '<span class="nky-qty-num">' + item.quantity + '</span>';
        html += '<button class="nky-qty-btn nky-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" type="button">+</button>';
        html += '</div>';
        html += priceHtml;
        html += '</div>';
        html += '<button class="nky-item-remove" data-key="' + item.key + '" type="button">Remove</button>';
        html += '<button class="nky-item-save-later" data-key="' + item.key + '" data-product-id="' + item.product_id + '" data-handle="' + item.handle + '" data-variant-id="' + item.variant_id + '" data-variant-title="' + self.escHtml(item.variant_title || '') + '" data-price="' + (item.final_price / 100) + '" type="button">Save for later</button>';
        html += '</div></div>';
      });

      container.innerHTML = html;
      this.bindItemEvents();
    },

    bindItemEvents: function () {
      var self = this;
      document.querySelectorAll('.nky-qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.updateItem(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10));
        });
      });
      document.querySelectorAll('.nky-item-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.updateItem(btn.getAttribute('data-key'), 0);
        });
      });
      document.querySelectorAll('.nky-item-save-later').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var productId = btn.getAttribute('data-product-id');
          var handle = btn.getAttribute('data-handle');
          var variantId = btn.getAttribute('data-variant-id');
          var variantTitle = btn.getAttribute('data-variant-title');
          var price = btn.getAttribute('data-price');
          var key = btn.getAttribute('data-key');

          if (typeof nkyWishlistToggle === 'function') {
            btn.textContent = 'Saving...';
            btn.disabled = true;

            var tempBtn = document.createElement('button');
            tempBtn.setAttribute('data-product-id', productId);
            tempBtn.setAttribute('data-product-handle', handle);

            nkyWishlistToggle(productId, handle, tempBtn, variantId, variantTitle, price);

            setTimeout(function () {
              self.updateItem(key, 0);
            }, 250);
          } else {
            alert('Wishlist is still loading. Please try again.');
          }
        });
      });
    },

    updateItem: function (key, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) { self.render(cart); });
    },

    // ── Footer ────────────────────────────────────────────────
    renderFooter: function (cart) {
      var subtotalEl = document.getElementById('nky-subtotal-amount');
      if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);

      var savingsEl = document.getElementById('nky-savings');
      if (savingsEl) {
        var totalDiscount = 0;
        cart.cart_level_discount_applications.forEach(function (d) {
          totalDiscount += d.total_allocated_amount;
        });
        if (totalDiscount > 0) {
          savingsEl.style.display = 'block';
          savingsEl.textContent = 'You\'re saving ' + this.formatMoney(totalDiscount);
        } else {
          savingsEl.style.display = 'none';
        }
      }

      this.renderCheckoutBtn();
    },

    renderCheckoutBtn: function (url) {
      var checkoutUrl = url || '/checkout';
      var btn     = document.getElementById('nky-checkout-btn');
      var exitBtn = document.getElementById('nky-exit-checkout');
      if (btn)     btn.href     = checkoutUrl;
      if (exitBtn) exitBtn.href = checkoutUrl;
    },

    // ── Rec scroll drag on desktop ────────────────────────────
    renderRecommendations: function (productId) {
      var el     = document.getElementById('nky-recommendations');
      var scroll = document.getElementById('nky-rec-scroll');
      if (!el || !scroll) return;

      fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.products || data.products.length === 0) {
            el.style.display = 'none'; return;
          }
          var html = '';
          data.products.forEach(function (p) {
            var imgSrc = '';
            if (p.featured_image) {
              imgSrc = p.featured_image.replace(/(\.\w+)(\?.*)?$/, '_240x240_crop_center$1');
            } else if (p.images && p.images.length > 0) {
              imgSrc = p.images[0].src.replace(/(\.\w+)(\?.*)?$/, '_240x240_crop_center$1');
            }
            var price = NKYCart.formatMoney(p.variants[0].price);
            var title = p.title.length > 24 ? p.title.substring(0, 24) + '\u2026' : p.title;
            html += '<div class="nky-rec-card">';
            html += '<a href="' + p.url + '" draggable="false">';
            if (imgSrc) {
              html += '<img class="nky-rec-img" src="' + imgSrc + '" alt="' + NKYCart.escHtml(p.title) + '" loading="lazy" draggable="false"/>';
            } else {
              html += '<div class="nky-rec-img-placeholder"></div>';
            }
            html += '</a>';
            html += '<div class="nky-rec-body">';
            html += '<p class="nky-rec-title">' + NKYCart.escHtml(title) + '</p>';
            html += '<p class="nky-rec-price">' + price + '</p>';
            html += '<a href="' + p.url + '" class="nky-rec-view" draggable="false">View</a>';
            html += '</div></div>';
          });
          scroll.innerHTML = html;
          el.style.display = 'block';

          var isDown = false, startX, scrollLeft;
          scroll.addEventListener('mousedown', function (e) {
            isDown = true;
            startX = e.pageX - scroll.offsetLeft;
            scrollLeft = scroll.scrollLeft;
            scroll.style.cursor = 'grabbing';
          });
          scroll.addEventListener('mouseleave', function () { isDown = false; scroll.style.cursor = 'grab'; });
          scroll.addEventListener('mouseup',    function () { isDown = false; scroll.style.cursor = 'grab'; });
          scroll.addEventListener('mousemove',  function (e) {
            if (!isDown) return;
            e.preventDefault();
            var x    = e.pageX - scroll.offsetLeft;
            var walk = (x - startX) * 1.5;
            scroll.scrollLeft = scrollLeft - walk;
          });
        })
        .catch(function () { el.style.display = 'none'; });
    },

    // ── Helpers ───────────────────────────────────────────────
    formatMoney: function (cents) {
      return (cents / 100).toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
      });
    },

    escHtml: function (str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { NKYCart.init(); });
  } else {
    NKYCart.init();
  }

})();